export default [
  {
    query: 'nuxe',
    suggestions: ['reve de miel', 'creme', 'levres', 'huile', 'men'],
  },
  {
    query: 'Avéne',
    suggestions: [
      'solaire',
      'hydrance',
      'cleanance',
      'cicalfate',
      'tolerance ',
    ],
  },
  {
    query: 'la roche posay',
    suggestions: ['effaclar', 'anthelios', 'lipikar', 'serum', 'hydraphase'],
  },
  {
    query: 'svr',
    suggestions: ['solaire', 'topialyse', 'serum', 'sebiaclear', 'gel'],
  },
  {
    query: 'mycose',
    suggestions: ['ongle', 'pieds', 'vulvovaginale', 'ongle pieds', 'vernis'],
  },

  {
    query: 'eucerin',
    suggestions: ['anti pigment', 'oil', 'hyaluron', 'sun', 'anti'],
  },
  {
    query: 'magnesium',
    suggestions: ['marin', 'b6', 'bisglycinate', 'enfant', 'marin b6'],
  },
  {
    query: 'bioderma',
    suggestions: ['atoderm', 'photoderm', 'sebium', 'node', 'crème'],
  },
  {
    query: 'creme solaire',
    suggestions: ['visage', 'enfant', 'skinceuticals', 'bebe', 'bronzage'],
  },
  {
    query: 'sans gluten',
    suggestions: ['pain', 'farine', 'sans lactose', 'biscuits', 'produit'],
  },
  {
    query: 'mustela',
    suggestions: ['bebe', 'gel lavant', 'gel', 'creme', 'eau'],
  },
  {
    query: 'vitamine c',
    suggestions: ['acerola', '1000', 'serum', 'upsa', 'effervescents'],
  },
  {
    query: 'zinc',
    suggestions: [
      'complément alimentaire',
      'selenium',
      'nutergia',
      'gelules',
      'cuivre',
    ],
  },
  {
    query: 'schär',
    suggestions: [
      'pain',
      'sans gluten',
      'sclaree bio',
      'sharpsafe',
      'pain sans gluten',
    ],
  },
  {
    query: 'dr hauschka',
    suggestions: [
      'serum',
      'huile',
      'masque',
      'creme de jour',
      'creme regenerante',
    ],
  },
  {
    query: 'vitamine d',
    suggestions: [
      'forte',
      'vitamine d3',
      'vitamine d3 gouttes',
      'solgar',
      'enfant',
    ],
  },
  {
    query: 'Klorane',
    suggestions: [
      'bebe',
      'shampoing',
      'pivoine',
      'shampooing',
      'menthe aquatique',
    ],
  },
  {
    query: 'vitamine',
    suggestions: ['d', 'c', 'e', 'b12', 'd3'],
  },
  {
    query: 'collagene',
    suggestions: [
      'vitamine d',
      'vitamine c',
      'vitamine e',
      'vitamine b12',
      'vitamine d3',
    ],
  },
  {
    query: 'whey',
    suggestions: ['gold', 'optimum', 'protein', 'isolate', 'vanille'],
  },
]
